import React from 'react'
import HeroSection from '../Components/UI/HeroSection'


const Home = () => {
  return (
    <div>
      <HeroSection/>
    </div>
  )
}

export default Home;
